export default __webpack_public_path__ + "static/media/fix-b.9189d268.png";